module.exports = __webpack_public_path__ + "static/media/support.55fe384e.png";